import { ICustomerSummaryData } from "@app/dashboard/dashboard.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const customerSummariesAdapter: EntityAdapter<ICustomerSummaryData> = createEntityAdapter<ICustomerSummaryData>({
	selectId: summary => summary.accountId
});